package presentation.screens.business.onboard.select_business_type

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import com.friendly.shared.component.layout.VerticalGrid
import component.navigation.TopNavBar
import feature.businessType.handler.BusinessTypeHandler
import feature.businessType.viewModel.BusinessTypeViewModel
import presentation.screens.business.onboard.component.BusinessTypeCard
import presentation.screens.business.onboard.create_business_screen.CreateBusinessScreen
import theme.ThemeColor

class SelectBusinessTypeScreen : Screen {
    val viewModel = BusinessTypeViewModel()

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.current
        val businessTypes = viewModel.allBusinessType.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.retrieve()
        }
        Column(
            modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)
        ) {
            TopNavBar(title = "Select Type of Business", onBackPress = {
                navigator?.pop()
            })
            VerticalGrid(
                columns = 2
            ) {
                businessTypes.value.forEach { businessType ->
                    BusinessTypeCard(businessType = businessType, onClick = {
                        BusinessTypeHandler.shared().repository.businessType = it
                        navigator?.push(CreateBusinessScreen())
                    })
                }
            }
//            LazyColumn {
//                items(count = businessTypes.value.count()) { index ->
//                    BusinessTypeCard(businessType = businessTypes.value[index], onClick = {
//                        BusinessTypeHandler.shared().repository.businessType = it
//                        navigator?.push(CreateBusinessScreen())
//                    })
//                }
//            }
        }
    }
}
//@Composable
//fun SelectBusinessTypeScreen(on) {
//}